import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface EnergySaversProps {
    readOnly?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const EnergySavers: React.FC<EnergySaversProps> = ({ readOnly = false, propertyGuid, isReview = false }) => {
    const [energySavers, setEnergySavers] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Additional Features']?.['Energy Savers'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Additional Features': { ...s.values?.['Additional Features'], 'Energy Savers': v } } })
    );
    const label = 'Energy Savers';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={energySavers}
                />
            ) : (
                <TextBox
                    value={energySavers ?? ''}
                    onChange={(value) => setEnergySavers(value)}
                    label={label}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
